module.exports = __webpack_public_path__ + "img/asu_chs_logo.6294d6cd.png";